"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.Name = exports.Brand = exports.Bottom = void 0;
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1)
}));
const Brand = exports.Brand = (0, _mui.styled)(_mui.Typography)({
  display: '-webkit-box',
  letterSpacing: 2,
  lineHeight: 'normal',
  overflow: 'hidden',
  textAlign: 'left',
  textTransform: 'uppercase',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 1,
  width: '100%',
  '&:empty': {
    display: 'none'
  }
});
const Name = exports.Name = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  display: '-webkit-box',
  lineHeight: theme.spacing(4),
  overflow: 'hidden',
  textAlign: 'left',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 2,
  width: '100%'
}));
const Bottom = exports.Bottom = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(2),
  alignItems: 'center',
  flexWrap: 'wrap'
}));
//# sourceMappingURL=styles.js.map